/* Native search and ChatCast remain the owners of results and conversations. */
(() => {
  class HatchillSearchForm extends HTMLElement {
    static encodeExact(value) {
      return value.trim().split(/\s+/u).filter(Boolean).map(word => JSON.stringify(word)).join(' ');
    }
    static decodeExact(value) {
      if (!value?.trim()) return null;
      const words = value.match(/"(?:[^"\\]|\\.)*"/gu);
      if (!words || words.join(' ') !== value.trim()) return null;
      try { return words.map(word => JSON.parse(word)).join(' '); } catch { return null; }
    }
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.form?.querySelector('[name="q"]');
      const controls = this.querySelector('[data-search-modes]');
      if (!this.form || !this.input) return;
      const raw = new URLSearchParams(window.location.search).get('q') || '';
      const decoded = HatchillSearchForm.decodeExact(raw);
      if (decoded !== null) {
        this.input.value = decoded;
        if (typeof document.title === 'string') document.title = document.title.replaceAll(raw, decoded);
        this.closest('.template-search')?.querySelectorAll('.hs-search__result-summary,.hatchill-search-empty-recovery [role="status"],.hatchill-search-mobile-count,.hatchill-search-results-bar>span,.hatchill-search-filter-shell__header p').forEach(label => {
          label.textContent = label.textContent.replaceAll(raw, decoded);
        });
      }
      this.querySelectorAll('[data-search-mode]').forEach(radio => {
        radio.checked = radio.value === (!raw || decoded !== null ? 'exact' : 'related');
      });
      if (controls) controls.hidden = true;
      const wider = this.querySelector('[data-search-widen]');
      if (wider && decoded !== null) {
        const url = new URL(wider.href, window.location.origin);
        url.searchParams.set('q', decoded);
        url.searchParams.set('type', 'product');
        url.searchParams.set('matching', 'related');
        wider.href = url.href;
        wider.hidden = false;
      }
      this.submit = () => {
        const mode = this.querySelector('[data-search-mode]:checked')?.value;
        if (mode === 'exact' || (!mode && (!raw || decoded !== null))) {
          this.input.value = HatchillSearchForm.encodeExact(this.input.value);
        }
      };
      this.form.addEventListener('submit', this.submit);
    }
    disconnectedCallback() { this.form?.removeEventListener('submit', this.submit); }
  }
  if (!customElements.get('hatchill-search-form')) customElements.define('hatchill-search-form', HatchillSearchForm);

  /* Bind normal-flow mobile support only when the app's own launcher is ready. */
  let chatOpener = null, observedWidget = null, widgetObserver = null;
  let watchedShadow = null, shadowMountObserver = null;
  function connectChat() {
    const entries = document.querySelectorAll('[data-hatchill-chat]');
    const host = document.querySelector('[data-chatcast-website]');
    const shadow = host?.shadowRoot;
    const launcher = shadow?.querySelector('.cc-launcher-icon');
    const widget = shadow?.querySelector('.cc-widget[data-live="true"]');
    if (shadow && watchedShadow !== shadow) {
      watchedShadow = shadow;
      shadowMountObserver?.disconnect();
      shadowMountObserver = new MutationObserver(() => {
        if (connectChat()) shadowMountObserver.disconnect();
      });
      shadowMountObserver.observe(shadow, {childList:true, subtree:true});
    }
    if (!entries.length || !launcher || !widget) return false;
    if (!shadow.querySelector('#hatchill-chat-access')) {
      const style = document.createElement('style');
      style.id = 'hatchill-chat-access';
      style.textContent = '@media(max-width:749px){.cc-widget[data-live=true][data-open=false] .cc-launcher,.cc-invitation{display:none!important}}';
      shadow.append(style);
    }
    entries.forEach(button => { button.hidden = false; });
    if (observedWidget !== widget) {
      widgetObserver?.disconnect();
      observedWidget = widget;
      widgetObserver = new MutationObserver(() => {
        if (widget.dataset.open === 'false' && chatOpener?.isConnected) {
          const opener = chatOpener; chatOpener = null; opener.focus();
        }
      });
      widgetObserver.observe(widget, {attributes:true, attributeFilter:['data-open']});
    }
    return true;
  }
  document.addEventListener('click', event => {
    const entry = event.target.closest?.('[data-hatchill-chat]');
    if (!entry) return;
    const launcher = document.querySelector('[data-chatcast-website]')?.shadowRoot?.querySelector('.cc-launcher-icon');
    if (!launcher) return;
    /* Close the menu before opening the app dialog, avoiding overlapping focus traps. */
    const menu = entry.closest('side-drawer');
    const returnTarget = menu ? document.querySelector('button[aria-controls="Drawer-Menu"]') : entry;
    const openChat = () => { chatOpener = returnTarget; launcher.click(); };
    if (menu?.classList.contains('open')) Promise.resolve(menu.close()).then(openChat);
    else openChat();
  });
  if (document.body) {
    if (!connectChat()) {
      const mountObserver = new MutationObserver(() => {
        if (connectChat()) mountObserver.disconnect();
      });
      mountObserver.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['data-mounted']});
      window.addEventListener('pagehide', () => mountObserver.disconnect(), {once:true});
    }
    document.addEventListener('shopify:section:load', connectChat);
  }

  /* Preserve every policy word and the outer page H1; fix body heading semantics only. */
  if (location.pathname.endsWith('/policies/privacy-policy')) {
    document.querySelectorAll('.shopify-policy__body h1').forEach(heading => {
      const replacement = document.createElement('h2');
      for (const attribute of heading.attributes) replacement.setAttribute(attribute.name, attribute.value);
      while (heading.firstChild) replacement.append(heading.firstChild);
      heading.replaceWith(replacement);
    });
  }
})();

